import { gsap } from "gsap";
import { CSSPlugin } from "gsap/CSSPlugin";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import { SnowflakeIntro } from './intro';
import { SnowflakeChallenges } from './challenges';
import { SnowflakePolicyholderCost } from "./policyholder-cost";
import { SnowflakeOutro } from './outro';
import { SnowflakeBigfoot } from './bigfoot';

export class SnowflakeMain {
  init ( ): void {

  }

  constructor ( ) { }
}

interface SnowflakeNamespace {
  main: SnowflakeMain;
  intro: SnowflakeIntro;
  challenges: SnowflakeChallenges;
  pc: SnowflakePolicyholderCost;
  outro: SnowflakeOutro;
  bigfoot: SnowflakeBigfoot;
}

// register gsap plugins
gsap.registerPlugin( CSSPlugin );
gsap.registerPlugin( DrawSVGPlugin );
gsap.registerPlugin( ScrollToPlugin );
gsap.registerPlugin( ScrollTrigger );

// setup namespace
const sf: SnowflakeNamespace = {
  main: undefined,
  intro: undefined,
  challenges: undefined,
  pc: undefined,
  outro: undefined,
  bigfoot: undefined
};

// create classes and fulfill dependencies
sf.main = new SnowflakeMain();
sf.intro = new SnowflakeIntro();
sf.challenges = new SnowflakeChallenges();
sf.pc = new SnowflakePolicyholderCost();
sf.outro = new SnowflakeOutro();
sf.bigfoot = new SnowflakeBigfoot();

// fire init functions from each class after DOM is loaded.
document.addEventListener('DOMContentLoaded', () => {
  sf.main.init();
  sf.intro.init();
  sf.challenges.init();
  sf.pc.init();
  sf.outro.init();
  sf.bigfoot.init();
});
